import { render, staticRenderFns } from "./Group-Trash-Delete-Prompt.vue?vue&type=template&id=028f1069&scoped=true&"
import script from "./Group-Trash-Delete-Prompt.vue?vue&type=script&lang=js&"
export * from "./Group-Trash-Delete-Prompt.vue?vue&type=script&lang=js&"
import style0 from "./Group-Trash-Delete-Prompt.vue?vue&type=style&index=0&id=028f1069&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028f1069",
  null
  
)

export default component.exports